<template>
  <div class="container-fluid d-flex flex-column align-items-center justify-content-center" style="height: 100vh;">
      <div class="text-center">
          <h1 class="display-1 text-danger">404</h1>
          <h2 class="mb-4">Page Not Found</h2>
          <p>The page you are looking for does not exist.</p>
          <a @click="$router.push({ name: 'main-module' })" class="btn btn-primary">Go back to home</a>
      </div>
  </div>
</template>

<script>
export default {
  name: 'not-found',
  data: () => ({}),
  mounted() {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/default-page/404.vue